/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import Menu from './Menu';
import { NavLink } from 'react-router-dom';
import CommonClass from '../../js/common';
import {
	HOME_PAGE_UNLOADED,
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
	...state.home,
	appName: state.common.appName,
	token: state.common.token
});

const mapDispatchToProps = dispatch => ({
	onUnload: () =>
		dispatch({ type: HOME_PAGE_UNLOADED })
});

class AboutUS extends React.Component {
	componentWillMount() {

	}
	componentDidMount() {
		var CONTAINER_ORIGINAL_WIDTH = $('#MainContainer').css('width');
		var CONTAINER_ORIGINAL_HEIGHT = $('#MainContainer').css('height');

		var CONTAINER1_ORIGINAL_WIDTH = $(window).width();
		var CONTAINER1_ORIGINAL_HEIGHT = $(window).height();

		var mobileHightAdj = 50;
		var mobileWidthAdj = 50;

		var resizePadding = 1;
		var mousehover = 0;

		var isPortrait = false;
		var isMobile = false;

		if (window.matchMedia("(orientation: portrait)").matches) {
			// you're in PORTRAIT mode
			("First time Detected portrait mode!");
			isPortrait = true;
		}

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
			.test(navigator.userAgent)) {
			mousehover = 1;
			isMobile = true;
		} else {
			("Not a device...")
			if (isPortrait == true) {
				("Desktop portrait");
				$("#portrait-blocker").hide();
			}
		}
		$("#MainContainer").css('width', CONTAINER_ORIGINAL_WIDTH);
		$("#MainContainer").css('height', CONTAINER_ORIGINAL_HEIGHT);

		var screen = {
			left: 0,
			top: 0,
			width: 0,
			height: 0
		};

		screen.width = window.innerWidth;
		screen.height = window.innerHeight;
		var scaleTo = 1;

		screenresize(true);;

		$(window).resize(function () {
			screenresize(true);;
		});

		function screenresize(isonload) {

			var width = $(window).width();
			var height = $(window).height();

			var maxWidth = window.screen.width;
			var maxHeight = window.screen.height;

			if (resizePadding == 1) {
				maxHeight = maxHeight + (mobileHightAdj);
				maxWidth = maxWidth + (mobileWidthAdj);
			}

			var scaleTo;

			if (width >= maxWidth && height >= maxHeight) {
				scaleTo = 1;
			} else {
				scaleTo = Math.min(width / maxWidth, height / maxHeight);
			}

			// $('#MainContainer').css({ "transform": "scale(" + scaleTo + ")" });

			var containerLeft = 0;
			if ($(window).width() < parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", ""))) {
				containerLeft = - (parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", "")) - $(window).width()) / 2;
			}
			$('#MainContainer').css('left', containerLeft);

			var containerTop = (height - (maxHeight * scaleTo)) / 2;

			if ($('.content-container').hasClass('active') == true) {
				$("#MainContainer").css('width', CONTAINER1_ORIGINAL_WIDTH);
				$("#MainContainer").css('height', CONTAINER1_ORIGINAL_HEIGHT);
			}
		}

	}
	componentWillUnmount() {
		this.props.onUnload();
	}
	render() {
		return (
			<div className="content-resize-container" id="MainContainer">
				<Menu />
				<div className="main">
					<div className="main-content" id="aboutUs-content" style={{ 'border': 'solid 0px #000' }}>
						<img className="rn content-ring" src={CommonClass.cdn_url + "images/ContentRing.svg"} />
						<div className="apData abtUsWrapN about-us__hldr">
							<h2 className='title'>aspire analyticx</h2>
							<p className='desc'>Aspiricx is an Artificial Intelligence company. We are on a mission to push the boundaries of AI and computer vision to<br />develop our real-world scientific model we call “Aspire Analyticx”.<br />Aspire Analyticx is a full dimensional scientific model developed with the concept of modeling human potential using AI. <br /> <br /> We believe this will be the most path-breaking scientific advancement in the world of sports science. Decades of AI and deep learning research will be leveraged to explore the fullest potential of athletes and aspiring them to break their<br />boundaries by competing against their potential self. </p>
							<div className="arwAnimWrap caWrap">
								<span className="calltoAction">
									<span className="leftArw animArrows">
										<svg version="1.1" id="leftArrow" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 10" enableBackground="new 0 0 24 10">
											<g className="leftArwPath">
												<path id="leftR3" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M23.499,5l-7.665-4.499v8.998L23.499,5" />
												<path id="leftR2" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M15.834,5L8.169,0.501v8.998L15.834,5" />
												<path id="leftR1" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M8.166,5L0.501,0.501v8.998L8.166,5" />
											</g>
										</svg>
									</span>
									<span> <NavLink to="/register" exact>ideali.me</NavLink></span>
									<span className="rightArw animArrows">
										<svg version="1.1" id="rightArrow" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 10" enableBackground="new 0 0 24 10">
											<g className="rightArwPath">
												<path id="rightL1" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M0.501,5l7.665,4.499V0.501L0.501,5" />
												<path id="rightL2" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M8.166,5l7.665,4.499V0.501L8.166,5" />
												<path id="rightL3" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M15.834,5l7.665,4.499V0.501L15.834,5" />
											</g>
										</svg>
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutUS);




// WEBPACK FOOTER //
// src/components/Home/Aboutus.js